// @flow
import React from 'react';
import {
  types as t,
  usePropsValidation,
} from '../validation/runtime-checks/index.js';
import { productColor } from '../designSystem.js';

// NOTE These compoennts would ideally be housed in SolidifyWorkedExample.js but
// there was a circular dependency issue that is solved by pulling it out
// into its own module.
export function SolidifyPartIndicator(props: {
  part: 'a' | 'b' | 'c' | 'd' | 'e' | 'f' | 'g',
}) {
  const { failedValidation } = usePropsValidation(props, SolidifyPartIndicator);
  if (failedValidation) return null;
  return <PartIndicatorInternal part={props.part} />;
}
SolidifyPartIndicator.spec = {
  part: t.unionOfValues('a', 'b', 'c', 'd', 'e', 'f', 'g'),
};

export function PartIndicatorInternal({ part }: { part: string }) {
  return (
    <div
      style={{
        width: 22,
        height: 22,
        background: productColor.eggplant20,
        color: productColor.cloudburst,
        borderRadius: '4px',
        fontWeight: 600,
        fontSize: 16,
        lineHeight: '22px',
        textAlign: 'center',
        display: 'inline-block',
        marginRight: '2px',
      }}
    >
      <span style={{ marginTop: -2 }}>{part}</span>
    </div>
  );
}
